import { pathOr } from 'ramda';
import { config } from '../../config';
import { isHttpNoResponseError } from '../../utils/httpErrors';
import { NoResponseError } from '../errors/NoResponseError';
import { buildApiClient } from './buildApiClient';

const { RESTREAM_WEB_API_HOST } = config;

export const apiClient = buildApiClient({
  baseUrl: RESTREAM_WEB_API_HOST,
  onError: (err, _apiClient) => {
    if (isHttpNoResponseError(err)) {
      const error = new NoResponseError(
        `No response: ${pathOr("Can't get url", ['config', 'url'], err)}`,
      );
      return Promise.reject(error);
    }

    // if (err && err.response && err.response.status === 401) {
    //   return (window.location.href =
    //     RESTREAM_WEB_HOST +
    //     `/login?continue=${encodeURIComponent(window.location.href)}`);
    // }

    return Promise.reject(err);
  },
});
